import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.members/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageMembersComponent implements OnInit {
    public loading: boolean = false;
    public members: any[] = [];
    public search: any = { text: "", role: "" };
    public roles: string[] = ['admin', 'therapist', 'reviewer'];
    public showInviteModal: boolean = false;
    public inviteData: any = { email: '', role: 'reviewer' };
    private inviteReturnFocus: HTMLElement | null = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("list", this.search);
        if (code === 200) this.members = data || [];
        this.loading = false;
        await this.service.render();
    }

    public async filterByRole(role: string) {
        this.search.role = this.search.role === role ? "" : role;
        await this.load();
    }

    public async openInvite() {
        this.inviteReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.inviteData = { email: '', role: 'reviewer' };
        this.showInviteModal = true;
        await this.service.render();
        setTimeout(() => document.getElementById('member-invite-email')?.focus(), 0);
    }

    public async closeInvite() {
        this.showInviteModal = false;
        await this.service.render();
        const target = this.inviteReturnFocus;
        this.inviteReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onInviteKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeInvite();
            return;
        }
        if (event.key !== 'Tab') return;

        const dialog = document.getElementById('member-invite-dialog');
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public async invite() {
        if (!this.inviteData.email) {
            await this.service.modal.error("이메일을 입력해주세요.");
            return;
        }
        const { code, data } = await wiz.call("invite", {
            ...this.inviteData,
            csrf_token: this.service.auth.session?.csrf_token || ''
        });
        if (code === 200) {
            await this.service.modal.success(
                `초대가 완료되었습니다. 임시 비밀번호: ${data.temporary_password} (안전한 채널로 전달해주세요.)`
            );
            await this.closeInvite();
            await this.load();
        } else {
            await this.service.modal.error(data?.message || "초대에 실패했습니다.");
        }
    }

    public async updateRole(member: any, role: string) {
        if (role === member.role) return;
        const { code, data } = await wiz.call("update_access", {
            id: member.id,
            role,
            csrf_token: this.service.auth.session?.csrf_token || ''
        });
        if (code === 200) await this.load();
        else {
            await this.service.modal.error(data?.message || "역할 변경에 실패했습니다.");
            await this.load();
        }
    }

    public async toggleStatus(member: any) {
        const next = member.status === 'active' ? 'disabled' : 'active';
        const action = next === 'active' ? '활성화' : '비활성화';
        const message = member.is_pending_signup
            ? `${member.name} 계정의 본인 확인을 완료했습니까? 먼저 제한 계정으로만 활성화되며, 임상 역할은 이후 별도로 부여해야 합니다.`
            : `${member.name} 계정을 ${action}하시겠습니까?`;
        const confirmed = await this.service.modal.show({
            title: member.is_pending_signup ? '가입 신청 승인' : `계정 ${action}`,
            message,
            action: member.is_pending_signup ? '승인' : action,
            actionBtn: next === 'active' ? 'success' : 'error',
            status: next === 'active' ? 'success' : 'error'
        });
        if (!confirmed) return;

        const { code, data } = await wiz.call("update_access", {
            id: member.id,
            status: next,
            csrf_token: this.service.auth.session?.csrf_token || ''
        });
        if (code === 200) {
            await this.load();
            if (data?.temporary_password) {
                await this.service.modal.success(
                    `가입 신청을 승인했습니다. 초기 비밀번호: ${data.temporary_password} (본인 확인을 마친 안전한 채널로 전달해주세요.)`
                );
            }
        } else {
            await this.service.modal.error(data?.message || `계정 ${action}에 실패했습니다.`);
        }
    }

    public roleLabel(role: string) {
        const labels: any = {
            admin: '관리자', therapist: '치료자', reviewer: '검수자',
            viewer: '제한 계정', restricted: '제한 계정'
        };
        return labels[role] || '제한 계정';
    }

    public roleClass(role: string) {
        switch (role) {
            case 'admin': return 'bg-purple-100 text-purple-700';
            case 'therapist': return 'bg-blue-100 text-blue-700';
            case 'reviewer': return 'bg-emerald-100 text-emerald-700';
            default: return 'bg-gray-100 text-gray-600';
        }
    }
}

export default PageMembersComponent;